import { useEffect, useRef, useState } from "react";
import InputText1 from "../components/InputText1";
import Button2 from "../components/Button2";
import AlertModal from "../components/AlertModal";
import { adminServices } from "../services/AdminServices";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import { useParams } from "react-router-dom";
import withAuthorization from "../components/withAuthorization";
import DisabledModal from "../components/DisabledModal";
import Button from "../components/Button";
import Dropdown from "../components/Dropdown";
const KioskPageEdit = () => {
  let {
    kioskId
  } = useParams();
  const [deviceId, setDeviceID] = useState('');
  const [serialNumber, setSerialNumber] = useState('');
  const [kioskName, setKioskName] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [kioskInfo, setKioskInfo] = useState({});
  const [kioskPin, setKioskPin] = useState('');
  const [quadrants, setQuadrants] = useState(["N/A"]);
  const [colony, setColony] = useState(null);
  const [colonies, setColonies] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const hasInitializedFromKiosk = useRef(false);
  const initialColonyRef = useRef(null);
  useEffect(() => {
    if (kioskId) {
      kioskData();
      getColonies();
    }
  }, []);
  useEffect(() => {
    if (colony) {
      const fac = colonies.find(c => c.value == colony)?.fac;
      setFacilities(fac || []);

      // Only reset if the user changes colony away from the initially-loaded one.
      if (hasInitializedFromKiosk.current && initialColonyRef.current != null && colony != initialColonyRef.current) {
        setQuadrants(["N/A"]);
      }
      return;
    }
    setFacilities([]);
    if (hasInitializedFromKiosk.current && initialColonyRef.current != null) {
      setQuadrants(["N/A"]);
    }
  }, [colony, colonies]);
  const normalizeQuadrantValue = value => {
    if (value == null || value === "") return null;
    if (value === "N/A") return "N/A";
    return String(value);
  };
  const handleCheckboxChange = value => {
    setQuadrants(prev => {
      const normalized = normalizeQuadrantValue(value);
      if (normalized == null) return prev;
      if (prev.includes(normalized)) {
        const next = prev.filter(item => item !== normalized);
        return next.length > 0 ? next : ["N/A"];
      }
      return [...prev, normalized];
    });
  };
  const getColonies = () => {
    adminServices.storeProcedure2('getColonies', {}).then(r => {
      const data = r.data || [];
      const opts = data.map(c => ({
        value: c.colony_id,
        label: c.colony_name,
        fac: JSON.parse(c.facilities || [])
      }));
      var defaultOption = {
        label: '--- Select Kiosk Location ---',
        value: null
      };
      setColonies([defaultOption, ...opts]);
    }).catch(e => {
      //console.log('getColonies error', e);
    });
  };
  const kioskData = async () => {
    await adminServices.getKioskData(kioskId).then(r => {
      if (r.status == 200) {
        setKioskInfo(r.data);
        setDeviceID(r.data.appDeviceId);
        setSerialNumber(r.data.serialNumber);
        setKioskName(r.data.kioskName);
        setKioskPin(r.data.devicePin);
        const saved = String(r.data.quadrants || "").split("|").map(v => normalizeQuadrantValue(v)).filter(Boolean);
        setQuadrants(saved.length > 0 ? saved : ["N/A"]);

        // Best-effort: support different backend field names.
        const savedColony = r.data.colony ?? r.data.colonyId ?? r.data.storeLocation ?? null;
        if (savedColony != null) {
          initialColonyRef.current = savedColony;
          setColony(savedColony);
        }
        hasInitializedFromKiosk.current = true;
      }
    }).catch(error => {
      if (error.status == 401) {
        window.location.href = "/";
      }
    });
  };
  return <div style={{
    width: '100%'
  }}>
        <DisabledModal show={kioskInfo.deviceStatusId === 4} message={"This kiosk is disabled. Please enable first to edit."} btnLabel={"Enable Kiosk"} onEnable={async () => {
      await adminServices.storeProcedure2("setKioskStatus", {
        kioskId: kioskId,
        statusId: 1
      }).then(r => {
        window.location.reload();
      }).catch(e => {
        if (e.status == 401) {
          window.location.href = "/";
        }
      });
    }} />
        <h2>Edit Kiosk Terminal</h2>
        <AlertModal title={"Edit Kiosk Terminal"} show={showAlert} message={alertMessage} onClose={() => {
      setShowAlert(false);
    }}></AlertModal>
        <form className="padalaForm">
        <InputText1 title={"Kiosk Device ID*"} value={deviceId} placeholder={"App Device ID"} onChange={e => {
        setDeviceID(e.target.value);
      }} maxLength={50} />

        <InputText1 title={"Serial Number ID*"} value={serialNumber} placeholder={"Serial Number"} onChange={e => {
        setSerialNumber(e.target.value);
      }} maxLength={50} />

        <InputText1 title={"Kiosk Name*"} value={kioskName} placeholder={"Kiosk Name"} onChange={e => {
        setKioskName(e.target.value);
      }} maxLength={50} />

        <InputText1 title={"Kiosk Password*"} value={kioskPin} type="password" placeholder={"Assign a Kiosk Password"} onChange={e => {
        setKioskPin(e.target.value);
      }} maxLength={50} />

        <Dropdown title={"Store Location"} data={colonies} value={colony} onChange={e => {
        const val = e.target.value;
        setColony(val);
      }} />
        </form>

        <div className="mt-3 mb-3">
            <div className="mb-2 fw-semibold">Facilities / Quadrants</div>
            <div className="row row-cols-1 row-cols-md-3 g-2">
                <div className="col">
                    <div className="form-check border rounded px-3 py-2 h-100">
                        <input id="kiosk-edit-facility-na" className="form-check-input" type="checkbox" checked={quadrants.includes("N/A")} onChange={() => handleCheckboxChange("N/A")} />
                        <label className="form-check-label" htmlFor="kiosk-edit-facility-na">
                            Not Applicable
                        </label>
                    </div>
                </div>

                {facilities.map((facility, idx) => {
          const key = facility?.FacilityId ?? facility?.Facility ?? idx;
          const normalizedId = normalizeQuadrantValue(facility?.FacilityId);
          const id = `kiosk-edit-facility-${String(facility?.FacilityId ?? idx)}`;
          return <div className="col" key={key}>
                            <div className="form-check border rounded px-3 py-2 h-100">
                                <input id={id} className="form-check-input" type="checkbox" checked={normalizedId ? quadrants.includes(normalizedId) : false} onChange={() => handleCheckboxChange(facility?.FacilityId)} />
                                <label className="form-check-label" htmlFor={id}>
                                    {String(facility?.Facility ?? "")}
                                </label>
                            </div>
                        </div>;
        })}
            </div>
        </div>

        <div className="btn-group">

            <Button variant={"success"} size={"lg"} onClick={async () => {
        if (deviceId === '') {
          setAlertMessage('Kiosk Device ID Required');
          setShowAlert(true);
          return;
        }
        if (serialNumber === '') {
          setAlertMessage('Serial Number Required');
          setShowAlert(true);
          return;
        }
        if (kioskName === '') {
          setAlertMessage('Kiosk Name Required');
          setShowAlert(true);
          return;
        }
        if (kioskPin === '') {
          setAlertMessage('Kiosk PIN Code Required');
          setShowAlert(true);
          return;
        }
        let form = kioskInfo;
        form.appDeviceId = deviceId;
        form.serialNumber = serialNumber;
        form.kioskName = kioskName;
        form.devicePin = kioskPin;
        form.quadrants = quadrants.join("|");
        form.colony = colony;
        await adminServices.updateKiosk(form).then(r => {
          if (r.status == 201 || r.status == 204 || r.status == 200) {
            window.location.href = "/kiosk-status-reports";
          }
        }).catch(e => {
          if (e.status == 401) {
            window.location.href = "/";
          }
          if (e.status == 500) {
            setAlertMessage("An error occured, please check for duplicate entries");
            setShowAlert(true);
          }
        });
      }}>Save Kiosk Info</Button>
            <Button variant={"danger"} size={"lg"} onClick={async () => {
        await adminServices.storeProcedure2("setKioskStatus", {
          kioskId: kioskId,
          statusId: 4
        }).then(r => {
          window.location.reload();
        }).catch(error => {
          if (error.status == 401) {
            window.location.href = "/";
          }
        });
      }}>Disable Kiosk</Button>
        </div>
    </div>;
};
export default withAuthorization(KioskPageEdit, 21);